<template>
  <div class="_component-side-helper" :style="style" v-if="isShow">
    <LoginModal v-if="isShowLoginModal" :initState="LOGIN_STATE.REGIST" :modal="true" @close="triggerLoginModal" />
    <Welfare v-if="isShowWelfare" @submit="handleClickSubmitWelfare" @close="triggerWelfare" />
    <Official class="bar-pop" v-if="isShowOfficial" @close="triggerOfficial" />
    <Serve class="bar-pop" v-if="isShowServe" @close="triggerServe" />
    <div class="bars-wrap">
      <div class="bar-item" @click="triggerWelfare" v-if="$store.state.Deadline.rdDiff !== Infinity && !$store.getters.isRdOver">
        <div class="item-content">
          <div class="item-icon img-wrap">
            <img src="//hsylc.oss-cn-hangzhou.aliyuncs.com/2024/side-helper/icon-1.png" alt="" />
          </div>
          <p class="text3 item-name color-gray-1">限时福利</p>
        </div>
      </div>
      <div class="bar-item" @click="triggerServe">
        <div class="item-content">
          <div class="item-icon img-wrap">
            <img src="//hsylc.oss-cn-hangzhou.aliyuncs.com/2024/side-helper/icon-2.png" alt="" />
          </div>
          <p class="text3 item-name color-gray-1">在线客服</p>
        </div>
      </div>
      <div class="bar-item" @click="triggerOfficial">
        <div class="item-content">
          <div class="item-icon img-wrap">
            <img src="//hsylc.oss-cn-hangzhou.aliyuncs.com/2024/side-helper/icon-3.png" alt="" />
          </div>
          <p class="text3 item-name color-gray-1">公众号</p>
        </div>
      </div>
      <div class="bar-item" @click="handleClickGoTop">
        <div class="item-content">
          <div class="item-icon img-wrap">
            <img src="//hsylc.oss-cn-hangzhou.aliyuncs.com/2024/side-helper/icon-4.png" alt="" />
          </div>
          <p class="text3 item-name color-gray-1">返回顶部</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import showPaths from './constants';
import Login from 'utils/login';
import LoginModal from 'components/login/Modal';
import LOGIN_STATE from 'components/login/loginState';
import Welfare from './Welfare';
import Track from 'utils/track';
import Serve from './Serve';
import Official from './Official';
import $ from 'jquery';
export default {
  name: 'SideHelper',
  components: {
    Serve,
    Official,
    Welfare,
    LoginModal
  },
  computed: {
    LOGIN_STATE() {
      return LOGIN_STATE;
    },
    scrollEl() {
      return '.app-wrapper';
    },
    style() {
      return {
        right: this.scrollBarWidth + 'px'
      };
    }
  },
  data: () => ({
    scrollBarWidth: 0,
    isShowServe: false,
    isShowOfficial: false,
    isShowWelfare: false,
    isShowLoginModal: false,
    isShow: false
  }),
  watch: {
    $route(to, from) {
      this.setStatus();
    }
  },
  mounted() {
    this.setStatus();
    setInterval(() => {
      this.setScrollBarWidth();
    }, 1000);
  },
  methods: {
    setStatus() {
      let path = window.location.pathname;
      if (showPaths.find(item => item.pathname === path)) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    handleClickSubmitWelfare() {
      this.triggerWelfare();
      if (Login.isLogin) {
        this.$stuStatusRedirect();
      } else {
        this.triggerLoginModal();
      }
    },
    triggerLoginModal() {
      this.isShowLoginModal = !this.isShowLoginModal;
    },
    triggerWelfare() {
      this.isShowWelfare = !this.isShowWelfare;
      if (this.isShowWelfare) {
        const track = new Track();
        track.track({
          event: '侧边栏点击限时福利'
        });
        this.isShowServe = false;
        this.isShowOfficial = false;
      }
    },
    triggerOfficial() {
      this.isShowOfficial = !this.isShowOfficial;
      if (this.isShowOfficial) {
        const track = new Track();
        track.track({
          event: '侧边栏点击微信公众号'
        });
        this.isShowServe = false;
      }
    },
    triggerServe() {
      this.isShowServe = !this.isShowServe;
      if (this.isShowServe) {
        const track = new Track();
        track.track({
          event: '侧边栏点击在线客服'
        });
        this.isShowOfficial = false;
      }
    },
    handleClickGoTop() {
      $(this.scrollEl).animate({ scrollTop: 0 }, 100);
      this.isShowServe = false;
      this.isShowOfficial = false;
    },
    hasScroll() {
      let ret = false;
      const el = $(this.scrollEl);
      if (el.css('overflow') !== 'hidden' && el.scrollTop() + el.innerHeight() <= el[0]?.scrollHeight + 1) {
        ret = true;
      }
      return ret;
    },
    setScrollBarWidth() {
      if (this.hasScroll()) {
        var outer = $('<div>')
          .css({ visibility: 'hidden', width: 100, overflow: 'scroll' })
          .appendTo('body');
        var inner = $('<div>')
          .css({ width: '100%' })
          .appendTo(outer);
        this.scrollBarWidth = 100 - inner.width();
        outer.remove();
      } else {
        this.scrollBarWidth = 0;
      }
    }
  }
};
</script>
<style lang="less" scoped src="./index.less"></style>
